import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GlobalState } from '../../../store';
import { login } from '../../../store/user/user.actions';
import { loginError, selectUserProcessing } from '../../../store/user/user.selectors';
import { Credentials } from '../../../types';
import { Subscription } from 'rxjs';
import { CaptchaComponent } from '@fan-shared/captcha/captcha.component';

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: false,
})
export class LoginFormComponent implements OnDestroy {
  @Output() goToRegister = new EventEmitter();
  @Output() goToForgot = new EventEmitter();
  @Output() goToValidate = new EventEmitter<string>();
  @Input() redirectHome = true;

  @ViewChild('dashCaptcha', { static: true }) dashCaptcha!: CaptchaComponent;

  credentials: Credentials = {
    email: '',
    password: '',
  };

  errorMessage = '';
  subscriptions: Subscription[] = [];
  validatingCaptcha = false;

  processing$ = this.store.select(selectUserProcessing);
  constructor(private store: Store<GlobalState>, private router: Router) {
    this.subscriptions.push(
      this.store.select(loginError).subscribe((error) => {
        if (error && error.includes('Your email has not been validated')) {
          this.goToValidate.emit(this.credentials.email);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach((sub) => sub.unsubscribe());
  }

  submit() {
    this.validatingCaptcha = true;
    this.dashCaptcha.startCaptcha();
  }

  login(token: string) {
    this.store.dispatch(
      login({
        credentials: { ...this.credentials },
        redirectHome: this.redirectHome,
        turnstileToken: token,
      })
    );
  }

  registerClick() {
    this.goToRegister.observers.length
      ? this.goToRegister.emit()
      : this.router.navigate(['/register']);
  }

  forgotClick() {
    this.goToForgot.observers.length ? this.goToForgot.emit() : this.router.navigate(['/forgot']);
  }

  onTokenGenerated(token: string) {
    this.validatingCaptcha = false;
    if (token) {
      this.login(token);
    }
  }
}
